
  import { ComputedRef, PropType, computed, defineComponent, inject } from 'vue'
  import { useI18n } from 'vue-i18n'

  import { ISport, ITranslatedSport } from '@/types/sports'
  import { translateSports } from '@/utils/sports'

  export default defineComponent({
    name: 'SportsMenu',
    props: {
      selectedSportIds: {
        type: Array as PropType<number[]>,
        default: () => [],
      },
      userSports: {
        type: Object as PropType<ISport[]>,
        required: true,
      },
    },
    emits: ['selectedSportIdsUpdate'],
    setup(props, { emit }) {
      const { t } = useI18n()
      const translatedSports: ComputedRef<ITranslatedSport[]> = computed(() =>
        translateSports(props.userSports, t)
      )

      function updateSelectedSportIds(sportId: number) {
        emit('selectedSportIdsUpdate', sportId)
      }

      return {
        sportColors: inject('sportColors'),
        translatedSports,
        updateSelectedSportIds,
      }
    },
  })
